/* Light Strike theme script. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var LS = window.LightStrike || {};
  LS.strings = LS.strings || {};
  LS.bundles = LS.bundles || { enabled: false, tiers: [{ qty: 1, pct: 0 }] };
  LS.protection = LS.protection || { variantId: null };
  LS.routes = LS.routes || {
    cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js'
  };

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || LS.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var negative = number < 0;
      number = Math.abs(number);
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var out = dollars + (parts[1] ? decimal + parts[1] : '');
      return (negative ? '-' : '') + out;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  LS.formatMoney = formatMoney;

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.href);
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) u.searchParams.set('width', width);
      return u.href;
    } catch (e) { return url; }
  }

  function tierFor(qty) {
    var pct = 0;
    (LS.bundles.tiers || []).forEach(function (t) { if (qty >= t.qty) pct = Number(t.pct) || 0; });
    return LS.bundles.enabled ? pct : 0;
  }

  function discounted(cents, pct) { return Math.round(cents * (100 - pct) / 100); }

  function requestJSON(url, options) {
    options = options || {};
    var headers = { Accept: 'application/json' };
    if (options.body) headers['Content-Type'] = 'application/json';
    options.headers = headers;
    return fetch(url, options).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || LS.strings.cartError || 'Error');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- Cart API ---------- */
  var Cart = {
    data: null,
    fetch: function () {
      return requestJSON(LS.routes.cart + '.js', { method: 'GET' })
        .then(function (c) { Cart.data = c; return c; });
    },
    add: function (items) {
      return requestJSON(LS.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: items }) });
    },
    change: function (key, quantity) {
      return requestJSON(LS.routes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
        .then(function (c) { Cart.data = c; return c; });
    },
    hasProtection: function (cart) {
      var id = LS.protection.variantId;
      return !!(id && cart && cart.items.some(function (i) { return i.variant_id === id; }));
    },
    protectionLine: function (cart) {
      var id = LS.protection.variantId;
      return cart && cart.items.filter(function (i) { return i.variant_id === id; })[0];
    }
  };
  LS.Cart = Cart;

  /* ---------- Cart rendering (drawer + cart page) ---------- */
  function lineDiscount(item) {
    var total = 0;
    (item.line_level_discount_allocations || []).forEach(function (a) { total += a.amount; });
    if (!total && item.original_line_price > item.final_line_price) total = item.original_line_price - item.final_line_price;
    return total;
  }

  function checkDiscounts(cart) {
    // Compare what the bundle selector advertises with what Shopify actually applied.
    if (!LS.bundles.enabled) return null;
    var byProduct = {};
    cart.items.forEach(function (i) {
      if (i.variant_id === LS.protection.variantId) return;
      (byProduct[i.product_id] = byProduct[i.product_id] || []).push(i);
    });
    var expected = 0, actual = 0, lines = 0;
    Object.keys(byProduct).forEach(function (pid) {
      var items = byProduct[pid];
      var qty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      var pct = tierFor(qty);
      items.forEach(function (i) {
       lines += i.quantity;
        expected += Math.round(i.original_line_price * pct / 100);
        actual += lineDiscount(i);
      });
    });
    var tolerance = lines + 1;
    if (Math.abs(expected - actual) > tolerance) return { expected: expected, actual: actual };
    return null;
  }

  function renderLines(container, cart) {
    var visible = cart.items.filter(function (i) { return i.variant_id !== LS.protection.variantId; });
    if (!visible.length) {
      container.innerHTML = '<div class="drawer__empty"><p>' + escapeHTML(LS.strings.empty || 'Your cart is empty.') +
        '</p><a class="button button--small" href="' + escapeHTML(LS.routes.allProducts || '/collections/all') + '">Continue shopping</a></div>';
      return;
    }
    container.innerHTML = visible.map(function (item) {
      var disc = lineDiscount(item);
      var discTitles = (item.line_level_discount_allocations || []).map(function (a) {
        return a.discount_application && a.discount_application.title;
      }).filter(Boolean).join(', ');
      var variant = item.product_has_only_default_variant || !item.variant_title ? '' :
        '<div class="cart-line__variant">' + escapeHTML(item.variant_title) + '</div>';
      var img = item.image ? '<img src="' + escapeHTML(sizedImage(item.image, 160)) + '" alt="" width="76" height="76" loading="lazy">' : '';
      return '<div class="cart-line" data-line-key="' + escapeHTML(item.key) + '">' +
        '<a class="cart-line__img" href="' + escapeHTML(item.url) + '" tabindex="-1">' + img + '</a>' +
        '<div>' +
          '<div class="cart-line__top"><div><a class="cart-line__title" href="' + escapeHTML(item.url) + '">' + escapeHTML(item.product_title) + '</a>' + variant + '</div>' +
          '<div class="cart-line__price">' +
            (disc > 0 ? '<span class="cart-line__was">' + formatMoney(item.original_line_price) + '</span>' : '') +
            '<span>' + formatMoney(item.final_line_price) + '</span>' +
            (disc > 0 ? '<span class="cart-line__disc">-' + formatMoney(disc) + (discTitles ? ' · ' + escapeHTML(discTitles) : '') + '</span>' : '') +
          '</div></div>' +
          '<div class="cart-line__actions">' +
            '<div class="qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-qty-input aria-label="Quantity for ' + escapeHTML(item.product_title) + '">' +
              '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove>' + escapeHTML(LS.strings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }

  function renderCart(cart) {
    Cart.data = cart;
    var visibleCount = cart.items.reduce(function (s, i) {
      return s + (i.variant_id === LS.protection.variantId ? 0 : i.quantity);
    }, 0);

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = visibleCount;
      el.hidden = visibleCount === 0;
    });

    document.querySelectorAll('[data-cart-root]').forEach(function (root) {
      var lines = root.querySelector('[data-cart-lines]');
      var foot = root.querySelector('[data-cart-foot]');
      if (lines) renderLines(lines, cart);
      if (foot) foot.hidden = visibleCount === 0;

      var savings = cart.total_discount || 0;
      var savingsRow = root.querySelector('[data-cart-savings-row]');
      var savingsEl = root.querySelector('[data-cart-savings]');
      if (savingsRow) savingsRow.hidden = savings <= 0;
      if (savingsEl) savingsEl.textContent = '-' + formatMoney(savings);
      var sub = root.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);

      var prot = root.querySelector('[data-cart-protection-input]');
      if (prot) prot.checked = Cart.hasProtection(cart);

      var mm = root.querySelector('[data-cart-mismatch]');
      var mismatch = checkDiscounts(cart);
      if (mismatch) {
        var msg = (LS.strings.mismatch || 'Expected [expected] off, Shopify applied [actual].')
          .replace('[expected]', formatMoney(mismatch.expected))
          .replace('[actual]', formatMoney(mismatch.actual));
        if (window.console) console.warn('[Light Strike] ' + msg);
        if (mm) { mm.textContent = msg; mm.hidden = !(LS.designMode || LS.preview); }
      } else if (mm) {
        mm.hidden = true;
      }
    });
    document.dispatchEvent(new CustomEvent('ls:cart-updated', { detail: cart }));
  }

  function refreshCart() {
    return Cart.fetch().then(function (cart) {
      // Shipping protection on its own makes no sense: remove it when the cart has nothing else.
      var prot = Cart.protectionLine(cart);
      if (prot && cart.items.length === 1) return Cart.change(prot.key, 0).then(renderCart);
      renderCart(cart);
      return cart;
    });
  }
  LS.refreshCart = refreshCart;

  function bindCartRoot(root) {
    root.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-qty-input]');
      var qty = parseInt(input.value, 10) || 0;
      var next = null;
      if (e.target.closest('[data-qty-minus]')) next = Math.max(0, qty - 1);
      if (e.target.closest('[data-qty-plus]')) next = qty + 1;
      if (e.target.closest('[data-line-remove]')) next = 0;
      if (next === null) return;
      updateLine(line, key, next);
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) {
        var line = e.target.closest('[data-line-key]');
        updateLine(line, line.getAttribute('data-line-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
      if (e.target.matches('[data-cart-protection-input]')) toggleProtection(e.target.checked, e.target);
    });
  }

  function updateLine(line, key, qty) {
    line.classList.add('is-loading');
    Cart.change(key, qty).then(function () { return refreshCart(); }).catch(function (err) {
      line.classList.remove('is-loading');
      alert(err.message);
    });
  }

  function toggleProtection(on, input) {
    var id = LS.protection.variantId;
    if (!id) return;
    if (input) input.disabled = true;
    var cart = Cart.data;
    var p = Cart.protectionLine(cart);
    var job;
    if (on && !p) job = Cart.add([{ id: id, quantity: 1 }]);
    else if (!on && p) job = Cart.change(p.key, 0);
    else job = Promise.resolve();
    job.then(refreshCart).catch(function (err) { alert(err.message); })
      .then(function () { if (input) input.disabled = false; });
    document.querySelectorAll('[data-protection-input]').forEach(function (el) { el.checked = on; });
  }

  /* ---------- Cart drawer ---------- */
  var Drawer = {
    el: null, lastFocus: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      if (!this.el) return;
      this.el.setAttribute('data-cart-root', '');
      bindCartRoot(this.el);
      var self = this;
      this.el.querySelectorAll('[data-drawer-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen()) self.close(); });
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cart-open]');
        if (!t || document.querySelector('[data-cart-page]')) return;
        e.preventDefault();
        self.open();
      });
    },
    isOpen: function () { return this.el && this.el.classList.contains('is-open'); },
    open: function () {
      if (!this.el) { window.location.href = LS.routes.cart; return; }
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      var panel = this.el.querySelector('.drawer__panel');
      setTimeout(function () { panel.focus(); }, 50);
      refreshCart().catch(function () {});
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };
  LS.Drawer = Drawer;

  /* ---------- Buy box ---------- */
  function BuyBox(el) {
    this.el = el;
    var json = el.querySelector('[data-product-json]');
    this.product = json ? JSON.parse(json.textContent) : { variants: [] };
    this.form = el.querySelector('[data-buy-form]');
    this.options = Array.prototype.slice.call(el.querySelectorAll('[data-bundle-option]'));
    this.itemRows = Array.prototype.slice.call(el.querySelectorAll('[data-bundle-item]'));
    this.protectionInput = el.querySelector('[data-protection-input]');
    this.addButton = el.querySelector('[data-add-button]');
    this.addLabel = el.querySelector('[data-add-label]');
    this.error = el.querySelector('[data-form-error]');
    this.summaryTotal = el.querySelector('[data-summary-total]');
    this.summarySave = el.querySelector('[data-summary-save]');
    this.defaultId = el.querySelector('[data-default-id]');
    this.defaultQty = el.querySelector('[data-default-qty]');
    this.qty = 1;
    this.listeners = [];
    var self = this;

    this.options.forEach(function (opt) {
      var radio = opt.querySelector('input');
      radio.addEventListener('change', function () { if (radio.checked) self.setQty(parseInt(radio.value, 10)); });
    });
    var checked = el.querySelector('[data-bundle-option] input:checked');
    if (checked) this.qty = parseInt(checked.value, 10) || 1;

    this.itemRows.forEach(function (row, idx) {
      var sel = row.querySelector('[data-item-select]');
      sel.addEventListener('change', function () {
        self.updateItemImage(row, sel.value);
        if (idx === 0) self.showVariantMedia(sel.value);
        self.update();
      });
    });
    if (this.protectionInput) this.protectionInput.addEventListener('change', function () { self.update(); });
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    this.update();
  }

  BuyBox.prototype.variant = function (id) {
    id = Number(id);
    return this.product.variants.filter(function (v) { return v.id === id; })[0];
  };

  BuyBox.prototype.selectedVariants = function () {
    var self = this, list = [];
    if (this.itemRows.length) {
      for (var i = 0; i < this.qty; i++) {
        var sel = this.itemRows[i] && this.itemRows[i].querySelector('[data-item-select]');
        list.push(this.variant(sel ? sel.value : this.defaultId.value));
      }
    } else {
      var v = this.variant(this.defaultId.value) || this.product.variants[0];
      for (var j = 0; j < this.qty; j++) list.push(v);
    }
    return list.filter(Boolean);
  };

  BuyBox.prototype.setQty = function (qty) {
    this.qty = qty || 1;
    this.options.forEach(function (opt) {
      var r = opt.querySelector('input');
      opt.classList.toggle('is-selected', r.checked);
    });
    this.itemRows.forEach(function (row, i) { row.hidden = i >= qty; });
    this.update();
  };

  BuyBox.prototype.updateItemImage = function (row, id) {
    var v = this.variant(id);
    var box = row.querySelector('[data-item-img]');
    if (v && v.image && box) box.innerHTML = '<img src="' + escapeHTML(v.image) + '" alt="' + escapeHTML(v.title) + '" width="52" height="52">';
  };

  BuyBox.prototype.showVariantMedia = function (id) {
    var v = this.variant(id);
    if (!v || !v.media_id) return;
    var section = this.el.closest('[data-product-section], .section') || document;
    var slide = section.querySelector('[data-media-id="' + v.media_id + '"]');
    if (slide && slide.parentElement) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  };

  BuyBox.prototype.state = function () {
    var variants = this.selectedVariants();
    var base = variants.reduce(function (s, v) { return s + v.price; }, 0);
    var pct = tierFor(this.qty);
    var total = discounted(base, pct);
    var available = variants.length > 0 && variants.every(function (v) { return v.available; });
    var protection = !!(this.protectionInput && this.protectionInput.checked && LS.protection.variantId);
    var grand = total + (protection ? (LS.protection.price || 0) : 0);
    return { variants: variants, base: base, pct: pct, total: total, saving: base - total, available: available, protection: protection, grand: grand };
  };

  BuyBox.prototype.update = function () {
    var s = this.state();
    var self = this;
    // Per-tier prices follow the first selected variant.
    var first = s.variants[0] || this.product.variants[0];
    this.options.forEach(function (opt) {
      var radio = opt.querySelector('input');
      var q = parseInt(radio.value, 10);
      var pct = Number(radio.getAttribute('data-pct')) || 0;
      var was = first.price * q;
      var tot = discounted(was, LS.bundles.enabled ? pct : 0);
      var t = opt.querySelector('[data-bundle-total]'); if (t) t.textContent = formatMoney(tot);
      var w = opt.querySelector('[data-bundle-was]'); if (w) w.textContent = formatMoney(was);
      var e = opt.querySelector('[data-bundle-each]'); if (e) e.textContent = formatMoney(Math.round(tot / q)) + ' ' + (LS.strings.each || 'each');
    });

    if (this.summaryTotal) this.summaryTotal.textContent = formatMoney(s.grand);
    if (this.summarySave) {
      this.summarySave.hidden = s.saving <= 0;
      this.summarySave.textContent = s.saving > 0 ? 'You save ' + formatMoney(s.saving) : '';
    }
    if (this.defaultId && s.variants[0]) this.defaultId.value = s.variants[0].id;
    if (this.defaultQty) this.defaultQty.value = this.qty;

    if (this.addButton) {
      this.addButton.disabled = !s.available;
      this.addLabel.textContent = s.available ? (LS.strings.addToCart || 'Add to cart') : (LS.strings.soldOut || 'Sold out');
    }
    this.listeners.forEach(function (fn) { fn(s, self); });
  };

  BuyBox.prototype.onChange = function (fn) { this.listeners.push(fn); fn(this.state(), this); };

  BuyBox.prototype.submit = function () {
    var s = this.state();
    if (!s.available || this.busy) return;
    var self = this;
    var counts = {}, order = [];
    s.variants.forEach(function (v) {
      if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
      counts[v.id]++;
    });
    var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
    var cartPromise = Cart.data ? Promise.resolve(Cart.data) : Cart.fetch().catch(function () { return null; });

    this.busy = true;
    this.addButton.setAttribute('aria-busy', 'true');
    this.addLabel.textContent = LS.strings.adding || 'Adding…';
    if (this.error) this.error.textContent = '';

    cartPromise.then(function (cart) {
      if (s.protection && !Cart.hasProtection(cart)) items.push({ id: LS.protection.variantId, quantity: 1 });
      return Cart.add(items);
    }).then(function () {
      return refreshCart();
    }).then(function () {
      Drawer.open();
    }).catch(function (err) {
      if (self.error) self.error.textContent = err.message || LS.strings.cartError;
    }).then(function () {
      self.busy = false;
      self.addButton.removeAttribute('aria-busy');
      self.update();
    });
  };

  /* ---------- Gallery ---------- */
  function Gallery(el) {
    var track = el.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = el.querySelector('[data-gallery-prev]');
    var next = el.querySelector('[data-gallery-next]');
    var gos = Array.prototype.slice.call(el.querySelectorAll('[data-gallery-go]'));
    var current = 0;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i === current && track.dataset.synced) return;
      track.dataset.synced = '1';
      current = i;
      gos.forEach(function (g) { g.setAttribute('aria-current', String(Number(g.getAttribute('data-gallery-go')) === i)); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    gos.forEach(function (g) { g.addEventListener('click', function () { go(Number(g.getAttribute('data-gallery-go'))); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    sync();
  }

  /* ---------- Sticky purchase bar ---------- */
  function StickyBar(bar, box) {
    var meta = bar.querySelector('[data-sticky-meta]');
    var btn = bar.querySelector('[data-sticky-add]');
    document.body.classList.add('has-sticky-buy');
    box.onChange(function (s) {
      var label = s.variants.length + (s.variants.length === 1 ? ' set' : ' sets') + ' · ' + formatMoney(s.grand);
      if (meta) meta.textContent = label;
      btn.disabled = !s.available;
      btn.textContent = s.available ? (LS.strings.addToCart || 'Add to cart') : (LS.strings.soldOut || 'Sold out');
    });
    btn.addEventListener('click', function () { box.submit(); });
    var target = box.addButton;
    if (!('IntersectionObserver' in window) || !target) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        btn.tabIndex = show ? 0 : -1;
      });
    }).observe(target);
  }

  /* ---------- Menu drawer ---------- */
  function initMenu() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    function set(open) {
      if (open) drawer.setAttribute('open', ''); else drawer.removeAttribute('open');
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
      if (open) { var f = drawer.querySelector('a, button'); if (f) f.focus(); } else openBtn.focus();
    }
    openBtn.addEventListener('click', function () { set(true); });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.hasAttribute('open')) set(false); });
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  function initDelivery(el) {
    var f = function (d) { return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }); };
    var now = new Date();
    var n = function (k) { return parseInt(el.getAttribute(k), 10) || 0; };
    var s1 = addBusinessDays(now, n('data-ship-min')), s2 = addBusinessDays(now, n('data-ship-max'));
    var d1 = addBusinessDays(now, n('data-deliver-min')), d2 = addBusinessDays(now, n('data-deliver-max'));
    el.querySelector('[data-date-ship]').textContent = f(s1) + (n('data-ship-max') !== n('data-ship-min') ? ' – ' + f(s2) : '');
    el.querySelector('[data-date-deliver]').textContent = f(d1) + (n('data-deliver-max') !== n('data-deliver-min') ? ' – ' + f(d2) : '');
  }

  /* ---------- Init ---------- */
  function init() {
    Drawer.init();
    var cartPage = document.querySelector('[data-cart-page]');
    if (cartPage) { cartPage.setAttribute('data-cart-root', ''); bindCartRoot(cartPage); refreshCart().catch(function () {}); }
    else Cart.fetch().then(function (c) { var s = document.querySelector('[data-cart-count]'); if (s) renderCart(c); }).catch(function () {});

    document.querySelectorAll('[data-gallery]').forEach(function (g) { new Gallery(g); });
    var boxes = [];
    document.querySelectorAll('buy-box').forEach(function (el) { var b = new BuyBox(el); el._buyBox = b; boxes.push(b); });

    var bar = document.querySelector('[data-sticky-buy]');
    if (bar) {
      var section = bar.previousElementSibling && bar.previousElementSibling.matches('[data-product-section]') ? bar.previousElementSibling : document.querySelector('[data-product-section]');
      var boxEl = section && section.querySelector('buy-box');
      if (boxEl && boxEl._buyBox) StickyBar(bar, boxEl._buyBox);
    }
    initMenu();
    document.querySelectorAll('[data-delivery]').forEach(initDelivery);
    if (LS.protection.defaultChecked) {
      document.querySelectorAll('[data-protection-input]').forEach(function (i) { i.checked = true; });
      boxes.forEach(function (b) { b.update(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-gallery]').forEach(function (g) { new Gallery(g); });
      e.target.querySelectorAll('buy-box').forEach(function (el) { el._buyBox = new BuyBox(el); });
    });
  }
})();
